import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CryptoService {

    constructor() { }

    encrypt(value: string): string {
        var key = CryptoJS.PBKDF2(environment.Crypto.Password, environment.Crypto.Salt, {
            keySize: 256 / 32,
            iterations: 65536
        });

        var encrypted = CryptoJS.AES.encrypt(this.encoder(value), key, {
            iv: this.toWordArray(environment.Crypto.KeyIV),
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC
        });

        return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
    }

    encoder(value: string) {
        return CryptoJS.enc.Utf8.parse(value);
    }

    private toWordArray(value: string) {
        return CryptoJS.enc.Utf8.parse(value);
    }

}
